import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_ANONYMOUS_MESSAGES_LIST,
  FETCH_ANONYMOUS_MESSAGES_LIST_ERROR,
  CLEAR_ANONYMOUS_MESSAGES_LIST,
  DELETE_ANONYMOUS_MESSAGE_SUCCESS,
  DELETE_ANONYMOUS_MESSAGE_ERROR,
  CLEAR_DELETE_ANONYMOUS_MESSAGE_STATUS,
  PATCH_MESSAGE_SETTINGS_SUCCESS,
  PATCH_MESSAGE_SETTINGS_ERROR,
  CLEAR_PATCH_MESSAGE_SETTINGS_STATUS,
  FETCH_ANONYMOUS_MESSAGES_CSV,
  FETCH_ANONYMOUS_MESSAGES_CSV_ERROR,
  CLEAR_FETCH_ANONYMOUS_MESSAGES_CSV,
} from 'redux/anonymous-messages/types';


export const fetchAnonymousMessagesList = (pageNumber = 1) => baseErrorsHandlerDecorator(
  FETCH_ANONYMOUS_MESSAGES_LIST,
  FETCH_ANONYMOUS_MESSAGES_LIST_ERROR,
  () => restapi.get(addLang(`messages/user_messages/?page=${pageNumber}`)),
  false,
);

export const clearAnonymousMessagesList = () => dispatch => {
  dispatch({
    type: CLEAR_ANONYMOUS_MESSAGES_LIST,
  });
};

export const deleteAnonymousMessage = id => baseErrorsHandlerDecorator(
  DELETE_ANONYMOUS_MESSAGE_SUCCESS,
  DELETE_ANONYMOUS_MESSAGE_ERROR,
  () => restapi.delete(addLang(`messages/user_messages/${id}/`)),
  false,
  true,
);

export const clearDeleteAnonymousMessageStatus = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_ANONYMOUS_MESSAGE_STATUS,
  });
};

export const patchMessageSettings = (id, formData) => baseErrorsHandlerDecorator(
  PATCH_MESSAGE_SETTINGS_SUCCESS,
  PATCH_MESSAGE_SETTINGS_ERROR,
  () => restapi.patch(addLang(`messages/user_messages/settings/${id}/`), formData),
  false,
  true,
);

export const clearPatchMessageSettingsStatus = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_MESSAGE_SETTINGS_STATUS,
  });
};

export const fetchAnonymousMessagesCsv = () => baseErrorsHandlerDecorator(
  FETCH_ANONYMOUS_MESSAGES_CSV,
  FETCH_ANONYMOUS_MESSAGES_CSV_ERROR,
  () => restapi.get(addLang('messages/user_messages/download/')),
  false,
);

export const clearFetchAnonymousMessagesCsv = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_ANONYMOUS_MESSAGES_CSV,
  });
};
